import React from "react";
import { FeatherAlertCircle } from "@subframe/core";
import { VendorTransferToOtherAccountsCategoryDetails } from "../../services/api";

interface VendorTransferToOtherAccountsViewContentProps {
  details: VendorTransferToOtherAccountsCategoryDetails | null;
  isLoading: boolean;
  currencySymbol: string;
}

const InfoRow: React.FC<{ label: string; value?: React.ReactNode }> = ({
  label,
  value,
}) => (
  <div className="flex flex-col gap-1 rounded-md border border-dashed border-neutral-border px-4 py-3">
    <span className="text-caption text-subtext-color">{label}</span>
    <span className="text-body-bold text-default-font">
      {value ?? <span className="text-subtext-color">—</span>}
    </span>
  </div>
);

const VendorTransferToOtherAccountsViewContent: React.FC<
  VendorTransferToOtherAccountsViewContentProps
> = ({ details, isLoading, currencySymbol }) => {
  if (isLoading) {
    return (
      <div className="flex w-full items-center justify-center rounded-md border border-dashed border-neutral-border bg-neutral-50 px-6 py-10 text-body text-subtext-color">
        Loading transfer details...
      </div>
    );
  }

  if (!details) {
    return (
      <div className="flex w-full flex-col items-center gap-2 rounded-md border border-dashed border-neutral-border bg-neutral-50 px-6 py-10 text-center text-body text-subtext-color">
        <FeatherAlertCircle className="text-neutral-400" />
        <span>Transfer details are not available for this transaction.</span>
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col gap-4 rounded-md border border-solid border-neutral-border bg-neutral-50 px-6 py-6">
      <div className="flex w-full items-center justify-between">
        <span className="text-heading-3 font-heading-3 text-default-font">
          Transfer to Other Accounts
        </span>
      </div>

      <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-2">
        <InfoRow label="From Account" value={details.from_account_name} />
        <InfoRow label="To Account" value={details.to_account_name} />
        <InfoRow
          label="Transfer Date"
          value={
            details.date
              ? new Date(details.date).toLocaleDateString()
              : undefined
          }
        />
        <InfoRow label="Payment Mode" value={details.payment_mode || "—"} />
        <InfoRow label="Reference #" value={details.reference_number || "—"} />
      </div>

      <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-2">
        <InfoRow
          label="Amount"
          value={
            <span className="text-heading-4 font-heading-4 text-default-font">
              {currencySymbol} {details.amount.toLocaleString("en-IN")}
            </span>
          }
        />
      </div>
    </div>
  );
};

export default VendorTransferToOtherAccountsViewContent;
